import React, { useState, useEffect } from "react";
import { stateOptions } from "../../layouts/states";
import "./AddressContextMenu.css";

const AddressContextMenu = ({ x, y, initialAddress = {}, onSave, onClose }) => {
  const [address, setAddress] = useState(initialAddress);

  useEffect(() => {
    setAddress(initialAddress);
  }, [initialAddress]);

  useEffect(() => {
    const handleClick = () => onClose();
    document.addEventListener("click", handleClick);
    return () => document.removeEventListener("click", handleClick);
  }, [onClose]);

  const handleFieldChange = (field, value) => {
    setAddress((prev) => ({ ...prev, [field]: value }));
  };

  const handleContainerClick = (e) => e.stopPropagation();

  const handleSave = (e) => {
    e.stopPropagation();
    if (onSave) {
      onSave(address);
    }
    onClose();
  };

  return (
    <div
      className="address-context-menu"
      style={{ position: "absolute", top: y, left: x, zIndex: 1000 }}
      onClick={handleContainerClick}
    >
      <label>
        Address 1
        <input
          type="text"
          value={address.address1 || ""}
          onChange={(e) => handleFieldChange("address1", e.target.value)}
        />
      </label>
      <label>
        Address 2
        <input
          type="text"
          value={address.address2 || ""}
          onChange={(e) => handleFieldChange("address2", e.target.value)}
        />
      </label>
      <label>
        City
        <input
          type="text"
          value={address.city || ""}
          onChange={(e) => handleFieldChange("city", e.target.value)}
        />
      </label>
      <label>
        State
        <select
          value={address.state || ""}
          onChange={(e) => handleFieldChange("state", e.target.value)}
        >
          <option value="">Select State</option>
          {stateOptions.map((option) => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </select>
      </label>
      <label>
        ZIP
        <input
          type="text"
          value={address.zip || ""}
          onChange={(e) => handleFieldChange("zip", e.target.value)}
        />
      </label>
      <label>
        Country
        <input
          type="text"
          value={address.country || ""}
          onChange={(e) => handleFieldChange("country", e.target.value)}
        />
      </label>
      <button className="save-button" onClick={handleSave}>
        Save
      </button>
    </div>
  );
};

export default AddressContextMenu;
